import ApiClient from "../../../apiClient";
import { BASE_URL, NOTIFICATION } from "../../../constant/apiEndPoint";
import CustomMessage from "../../../utils/CustomMessage";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const getAllNotificationAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${NOTIFICATION.getAllNotification}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_NOTIFICATION_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_NOTIFICATION_FAIL,
          payload: CustomMessage(error.status),
        });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const getNotificationByIdAction = (tran_id, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${NOTIFICATION.getNotificationById}=${tran_id}`, {}, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);

        dispatch({
          type: TYPE.GET_NOTIFICATION_BY_ID_SUCCESS,
          payload: response.data.result.data,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({
          type: TYPE.GET_NOTIFICATION_BY_ID_FAIL,
          payload: error?.data?.result?.message,
        });
        // CustomToast({
        //   type: "error",
        //   message: error?.data?.result?.message,
        //   options: { autoClose: 5000, position: "top-center" },
        // });
      });
  };
};

export const createNotificationAction = (payload, navigate) => {
  return (dispatch) => {
    dispatch(loadingToggleAction(dispatch, true));
    ApiClient.post(`${BASE_URL}${NOTIFICATION.createNotification}`, payload, true)
      .then((response) => {
        dispatch(loadingToggleAction(dispatch, false));
        // CustomToast({
        //   type: "success",
        //   message: response.data.result.message,
        //   options: { autoClose: 2000, position: "top-center" },
        // });
        dispatch({
          type: TYPE.CREATE_NOTIFICATION_SUCCESS,
          payload: response.data.result.data,
        });
        navigate("/notification");
      })
      .catch((error) => {
        dispatch(loadingToggleAction(dispatch, false));
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({ type: TYPE.CREATE_NOTIFICATION_FAIL, payload: error?.data?.result?.message });
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};
